(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["c_account-activation"]) return;
  try {
    
  (() => {
    const panel = document.querySelector('[data-activation-panel]');
    if (!panel) return;
    const form = panel.closest('form');
    const params = new URLSearchParams(window.location.search);
    const key = 'tabio:activation:' + panel.dataset.theme;
    let pending = false;
    try {
      const timestamp = Number(sessionStorage.getItem(key));
      pending = timestamp > 0 && Date.now() - timestamp < 15 * 60 * 1000;
    } catch {}
    const response = panel.dataset.state !== 'idle';
    const accountPost = /\/account\/?$/.test(window.location.pathname);
    const active = panel.dataset.active === 'true' || params.get('activate') === '1' || (pending && accountPost);
    panel.dataset.active = String(active);
    panel.hidden = !active;
    const clearPending = () => { try { sessionStorage.removeItem(key); } catch {} };
    if (response || !active) clearPending();
    if (active && response) panel.querySelector('[data-activation-feedback]')?.focus();
    form.addEventListener('submit', () => {
      try { sessionStorage.setItem(key, String(Date.now())); } catch {}
    });
    panel.querySelector('[data-activation-exit]')?.addEventListener('click', clearPending);
  })();

  } catch(e) { console.error(e); }
})();
})();
